<template>
	<div class="grid grid-cols-2 gap-4"><slot /></div>
</template>
